import { FactorForm } from 'core/types';
import type { IconProp } from 'components/Icon';
import { ReactNode } from 'react';

export const factorFormLabels: Record<FactorForm, ReactNode> = {
  COEFFICIENT: 'Coefficient',
  PERCENTAGE: 'Percentage',
};

export const factorKindIcons: Record<'CONSTANT' | 'MONTHLY' | 'WEEKLY' | 'LENGTH', IconProp> = {
  CONSTANT: 'tag',
  MONTHLY: 'chart-simple',
  WEEKLY: 'chart-simple',
  LENGTH: 'stopwatch',
};
